import React from "react";
import Image from "next/image";
import Link from "next/link";
interface EmptyStateProps {
  description: string;
  className?: string;
  component?: React.ReactNode;
}
export function EmptyState({
  description,
  className,
  component,
}: EmptyStateProps) {
  return (
    <div
      className={`w-full h-[60%] flex justify-center items-center ${className}`}>
      <div className="flex flex-col items-center">
        <Image
          src="/images/emptysearch.svg"
          width={80}
          height={80}
          alt="search"
        />
        <div className="text-center mt-6 text-gray-400">{description}</div>
        {component}
      </div>
    </div>
  );
}
